import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { ArrowRight } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/Reveal";
import { CALENDLY_URL } from "@/lib/scroll";

const FAQS = [
  {
    q: "Who sends the outreach?",
    a: "For the proof run, I do, on your behalf.",
  },
  {
    q: "Will you use my domain?",
    a: "No. Outreach goes from separate lookalike domains to protect yours.",
  },
  {
    q: "What happens after Day 7?",
    a: "You can run the plan yourself, or continue with the done-for-you monthly program.",
  },
  {
    q: "How many revisions?",
    a: "One round on messaging.",
  },
];

const Faq = () => (
  <section
    id="faq"
    data-testid="faq-section"
    className="scroll-mt-24 border-t border-line bg-white py-20 lg:py-28"
  >
    <div className="mx-auto grid max-w-7xl gap-14 px-4 sm:px-6 lg:grid-cols-[0.8fr_1.2fr] lg:px-12">
      <div className="lg:sticky lg:top-28 lg:self-start">
        <Reveal>
          <Eyebrow>FAQ</Eyebrow>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-6 font-serif text-3xl font-medium leading-[1.18] tracking-tight text-ink sm:text-4xl lg:text-5xl">
            Questions, answered straight.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-6 max-w-sm text-base leading-relaxed text-smoke">
            The four things founders usually ask before booking the fit call.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="faq-cta"
            className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-terra transition-colors hover:text-terra-dark"
          >
            Ask me on the fit call
            <ArrowRight className="h-4 w-4" />
          </a>
        </Reveal>
      </div>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="space-y-4">
          {FAQS.map((faq, i) => (
            <AccordionItem
              key={faq.q}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-2xl border border-line bg-cream px-6 transition-colors data-[state=open]:border-terra/40"
            >
              <AccordionTrigger className="py-5 text-left font-serif text-lg text-ink hover:no-underline">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-base leading-relaxed text-smoke">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default Faq;
